import { render, staticRenderFns } from "./IRConnection.vue?vue&type=template&id=5c3626d8"
import script from "./IRConnection.vue?vue&type=script&lang=js"
export * from "./IRConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports